'use strict';

//c3 Angualar Graph help http://jettro.github.io/c3-angular-directive/#getstarted
// http://jettro.github.io/c3-angular-directive/api-docs/1.3/chartAxis.html

/**
 * Importing CSS
 */
import 'c3/c3.css';

/**
 * Importing 3rd Party libs and modules
 */
import angular from 'angular';
import 'c3-angular/c3-angular.min';

/**
 * Importing Controllers, Service, Factories
 */
import UserLoginService from '../authentication/user-login.service.js';
import LogoutController from './logout.controller'


export default angular.module('appAnalyticsDashboard',
	[

	])
	.service('UserLoginService',UserLoginService)
	.config(['$stateProvider', function($stateProvider){
		$stateProvider
			.state('app.logout', {
				url:'/logout',
				controller:LogoutController,
				controllerAs:'vm'
			});
	}])
	.name;


// WEBPACK FOOTER //
// ./src/app/modules/dashboard/index.js